import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const LightingIcon = React.memo<IconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick, strokeWidth = 1.5 }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      {/* Light bulb icon */}
      {/* Bulb */}
      <path
        d="M9 18h6M10 21h4"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M12 2a7 7 0 0 0-4 12.7V16a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-1.3A7 7 0 0 0 12 2z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
        fill="none"
      />
      {/* Light rays */}
      <path
        d="M12 6v2"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        opacity="0.5"
      />
    </BaseIcon>
  ),
);

LightingIcon.displayName = 'LightingIcon';
